export default "__VITE_ASSET__CTetPHrS__"